export default {
    AboutUs: {
        "companyProfile": "Company Profile",
        "contactAddress": "Contact address"
    },
    DownLoadUs: {
      "serviceAndSupport": "Service and support"
    },
    Dynamic: {
      "theDevelopmentOfLangState": "The development of Lang state"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/en/index.en.js